import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import LeaveApi from "../../../axios/LeaveAndHoliday/LeaveApi";

const DeleteLeaveTypeDialog = ({
  open,
  onClose,
  leaveTypeInfo,
  onRefresh,
  refreshData,
}) => {
  const { t } = useTranslation();
  const { deleteLeaveType } = LeaveApi();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleSubmit = async () => {
    if (!leaveTypeInfo?.leaveTypeId) {
      toast.warn(t("common.select-a-row-first"));
      return;
    }

    setLoading(true);
    try {
      const payload = {
        langId: localStorage.getItem("i18nextLngId"),
        leaveTypeId: leaveTypeInfo.leaveTypeId,
      };
      const response = await deleteLeaveType(payload);

      if (response?.status === 200) {
        toast.success(t("common.delete-leave-type-successfully"));
        onRefresh?.();
        refreshData?.();
        onClose?.();
      } else {
        toast.error(response?.data?.message || t("common.error"));
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || t("common.network-or-server-error")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="delete"
      title={t("common.delete-leave-type")}
      subtitle={t("common.are-you-sure-delete-this-item")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleSubmit}
    />
  );
};

export default DeleteLeaveTypeDialog;
